import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { RATING_ICONS } from '../FormBuilder/QuestionTypeSpecificEditors/icon-pool';
import { QUESTION_TYPES } from '../FormBuilder/questionTypeConstants';
import { FiStar, FiLink } from 'react-icons/fi';
import styles from './AnswerRenderer.module.css';

const AnswerRenderer = ({ answer }) => {
    const { value, question } = answer;

    const S3_BASE_URL = process.env.REACT_APP_S3 || 'https://s3.quick-form.ru';

    if (value === null || value === '' || (Array.isArray(value) && value.length === 0)) {
        return <span className={styles.noAnswer}><FormattedMessage id="singleAnswerPage.noAnswer" /></span>;
    }

    switch (question.type) {
        case QUESTION_TYPES.RATING:
            const iconKey = question.config?.icon || 'star';
            const IconComponent = RATING_ICONS[iconKey]?.Icon || FiStar;
            const count = question.options?.length || 5;
            return (
                <div className={styles.ratingContainer}>
                    {Array.from({ length: count }, (_, i) => i + 1).map(v => (
                        <IconComponent key={v} className={`${styles.ratingIcon} ${value >= v ? styles.filled : ''} ${styles[iconKey]}`} />
                    ))}
                    <span className={styles.ratingValue}>({value} из {count})</span>
                </div>
            );

        case QUESTION_TYPES.CHECKBOX:
            // Теперь value - это массив строк, а не ID
            return (
                <ul className={styles.list}>
                    {(value || []).map((item, index) => <li key={index}>{item}</li>)}
                </ul>
            );

        case QUESTION_TYPES.FILE:
            return (
                <a href={`${value}`} target="_blank" rel="noopener noreferrer" className={styles.fileLink}>
                    <FiLink/> <span className={styles.fileName}>{value.split('/').pop()}</span>
                </a>
            );

        default:
            // Для radio, dropdown, text, paragraph, date, time - просто выводим текстовое значение
            return <span className={styles.textValue}>{value}</span>;
    }
};

export default AnswerRenderer;
